import PATHS from 'pages/paths'

const { UNAUTHENTICATED, AUTHENTICATED } = PATHS
const { LOGIN, SIGNUP } = UNAUTHENTICATED
const { DASHBOARD } = AUTHENTICATED

const DISABLED_BACK_ROUTES = [LOGIN, SIGNUP, DASHBOARD]

export default DISABLED_BACK_ROUTES
